/**
 * The per-row display-name OVERRIDES a line set states, for persisting on the spec.
 *
 * Only rows whose name differs from their element name are returned: everything else is already
 * answered by the closure's own `ancestor_display` server-side, so storing it would duplicate the deck
 * and go stale the moment the deck's own label changes.
 *
 * Pure + React-free (CLAUDE.md separation of concerns).
 */

import type { StudioDeck } from 'src/components/star-grid/reportStudio.types';

/** `element name -> report display name`, for the set the rows shelf points at. */
export const lineSetRowLabels = (deck: StudioDeck): Record<string, string> => {
  const referenced = new Set(deck.rows.map((row) => row.selection.reference_id).filter(Boolean));
  const out: Record<string, string> = {};
  for (const set of deck.line_sets) {
    if (!referenced.has(set.id)) continue;
    for (const entry of set.entries) {
      const member = entry.member_id?.trim();
      const label = entry.label?.trim();
      // A spacer has no name, and a label equal to the element states nothing the server cannot derive.
      if (!member || !label || label === member) continue;
      out[member] = label;
    }
  }
  return out;
};
